'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIButton from 'UIComponents/button/UIButton';
const CLASS_NAME = 'CodeMirror-hs-button';
const BUTTON_SIZE = 'extra-small';
const CODE_BUTTON_STYLE = {
  color: 'inherit',
  background: 'transparent'
};
export default class Button extends Component {
  renderCodeDisplay(children) {
    return /*#__PURE__*/_jsx("code", {
      style: CODE_BUTTON_STYLE,
      children: children
    });
  }

  render() {
    const _this$props = this.props,
          {
      active,
      className,
      codeButton,
      children
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, ["active", "className", "codeButton", "children"]); // UIButton's active class uses !important which messes up theme colors.


    const cx = classNames(CLASS_NAME, className, active && "cm-keyword cm-hs-active");
    return /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
      className: cx,
      size: BUTTON_SIZE,
      children: codeButton ? this.renderCodeDisplay(children) : children
    }));
  }

}
Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  codeButton: PropTypes.bool,
  active: PropTypes.bool
};